export const getCurrencySymbol = currency => {
    if (currency === 'eur') {
        return '€';
    }
    return '£';
};

export const parseTravelPattern = travelPattern => {
    if (!travelPattern) {
        return '';
    }

    const travelPatternArr = travelPattern.split('#');

    return travelPatternArr
        .map(item => {
            if (item === 'm') {
                return 'Mon';
            }

            if (item === 'tu') {
                return 'Tue';
            }

            if (item === 'w') {
                return 'Wed';
            }

            if (item === 'th') {
                return 'Thu';
            }

            if (item === 'f') {
                return 'Fri';
            }

            if (item === 'sa') {
                return 'Sat';
            }

            if (item === 'su') {
                return 'Sun';
            }

            return '';
        })
        .join('/');
};

export const getYearGroups = yearGroups => {
    const groups = [];
    const primaryGroups = ['reception', 1, 2, 3, 4, 5, 6];
    const secondaryGroups = [7, 8, 9, 10, 11];
    const sixthForm = [12, 13];

    if (!yearGroups) {
        return groups;
    }

    if (yearGroups.primary) {
        groups.push(...primaryGroups);
    }

    if (yearGroups.secondary) {
        groups.push(...secondaryGroups);
    }

    if (yearGroups.sixth_form) {
        groups.push(...sixthForm);
    }

    return groups;
};

export const getMinPrice = (ticket, service) => {
    if (
        ticket.pricing_model === 'Zonal' &&
        ticket.zone_prices &&
        service.zones
    ) {
        const validTicketZoneNames = Object.keys(ticket.zone_prices).filter(
            ticketZone =>
                service.zones.find(
                    serviceZone => serviceZone.name === ticketZone
                ) && ticket.zone_prices[ticketZone] > 0
        );

        const validTicketZonePrices = validTicketZoneNames.map(
            validZoneName => ticket.zone_prices[validZoneName]
        );

        const zonePrices = Object.values(validTicketZonePrices);
        const zoneMin = Math.min(...zonePrices).toFixed(2);
        return zoneMin;
    }

    return ticket.price;
};

export const hasValidZonePricing = (ticket, service) => {
    if (
        !service.zones ||
        !service.zones.length ||
        !ticket.zone_prices ||
        !Object.keys(ticket.zone_prices).length
    ) {
        return false;
    }

    const validTicketZones = Object.keys(ticket.zone_prices).filter(
        ticketZone =>
            service.zones.find(
                serviceZone => serviceZone.name === ticketZone
            ) && ticket.zone_prices[ticketZone] > 0
    );

    return validTicketZones.length > 0;
};
